<template>
  <MobileHeaderComponent />
  <!-- Header -->
  <div class="edrea_tm_header" :class="{ scrolled: scrolled }">
    <div class="header_inner">
      <div class="logo">
        <a href="#" @click="navFuntions.activeSection('home')"
          ><img src="img/logo/logo.jpeg" alt="DataMind"
        /></a>
      </div>
      <div class="menu">
        <Menu />
        <LanguageSwitcher />
      </div>
    </div>
  </div>
</template>

<script>
import { navFuntions } from "@/navFuntions";
import LanguageSwitcher from "./LanguageSwitcher.vue";
import Menu from "./Menu.vue";
import MobileHeaderComponent from "./MobileHeaderComponent.vue";
export default {
  name: `HeaderComponent`,
  components: { MobileHeaderComponent, Menu, LanguageSwitcher },
  data() {
    return {
      navFuntions,
      scrolled: false,
    };
  },
  methods: {
    handleScroll() {
      this.scrolled = window.scrollY > 60;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    this.handleScroll();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.menu {
  display: flex;
  align-items: center;
  gap: 30px;
}
</style>
